'use strict';

var parent = require('../../es/reflect');
module.exports = parent;